import React, {createContext} from 'react'


const TrackingContext = createContext({greet: "huhu"});

const TrackingProvider = ({tracker, children}) => {
  const version = '1.0.0'

  return(
    <TrackingContext.Provider value={{version, tracker}} >
      {children}
    </TrackingContext.Provider>
  )
}

export { TrackingProvider, TrackingContext }
